import sortableStations from "./sortableStations.component";

const sortableStationsModule = angular
  .module("app.components.sortableStations", [])
  .component("sortableStations", sortableStations);

export default sortableStationsModule;



// WEBPACK FOOTER //
// ./src/components/sortableStations/sortableStations.module.js